import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8001/api";

export const CLIENT_TOKEN_KEY = "bic_client_token";
export const STAFF_TOKEN_KEY = "bic_staff_token";

export function getClientToken() {
  return localStorage.getItem(CLIENT_TOKEN_KEY) || "";
}
export function setClientToken(t) {
  if (t) localStorage.setItem(CLIENT_TOKEN_KEY, t);
  else localStorage.removeItem(CLIENT_TOKEN_KEY);
}
export function getStaffToken() {
  return localStorage.getItem(STAFF_TOKEN_KEY) || "";
}
export function setStaffToken(t) {
  if (t) localStorage.setItem(STAFF_TOKEN_KEY, t);
  else localStorage.removeItem(STAFF_TOKEN_KEY);
}

function makeClient(scope) {
  const instance = axios.create({
    baseURL: BASE_URL,
    headers: { Accept: "application/json" },
  });

  instance.interceptors.request.use((config) => {
    const token = scope === "staff" ? getStaffToken() : getClientToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  instance.interceptors.response.use(
    (r) => r,
    (error) => {
      const status = error?.response?.status;
      if (status === 401) {
        if (scope === "staff") setStaffToken("");
        else setClientToken("");
        const isStaffPath = window.location.pathname.startsWith("/staff");
        const onAuthPage =
          window.location.pathname === "/login" ||
          window.location.pathname === "/staff/login" ||
          window.location.pathname.startsWith("/auth/verify");
        if (!onAuthPage) {
          window.location.href = isStaffPath ? "/staff/login" : "/login";
        }
      }
      return Promise.reject(error);
    }
  );

  return instance;
}

export const clientHttp = makeClient("client");
export const staffHttp = makeClient("staff");

export function apiBaseUrl() {
  return BASE_URL;
}
